import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {MQ24GPGA460AdvancedModel} from "./models/MQ24GModels";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import RowTRComponent from "./components/RowTRComponent";


const MiniQ2AdvancedForm = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...MQ24GPGA460AdvancedModel});

    useEffect(() => {
        if (item.id) {
            setValues({...item.payload});
        } else {
            setValues({...MQ24GPGA460AdvancedModel});
        }
    }, [item]);


    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5 table-middle">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-end" colSpan="2">{_Tf("common.parameters")}</th>

                    </tr>
                    </thead>
                    <tbody>
                    {
                        Object.keys(values).map((key, index) =>(
                            <RowTRComponent
                                key={index}
                                fieldName={key}
                                _TC={_TC}
                                valueIn={values[key]}
                                deactivated={MQ24GPGA460AdvancedModel[key]}
                            />
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default MiniQ2AdvancedForm